// Vuex state store

import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/i18n'

Vue.use(Vuex)

import BrandRepository from '../repositories/BrandRepository'
import TeamRepository from '../repositories/TeamRepository'
import GroupRepository from '../repositories/GroupRepository'
import SnackbarModule from './snackbar'
import MarkerRepository from '@/repositories/MarkerRepository'

const state = {
  brands: null,
  authenticated: false,
  teamId: null,
  consumerName: null,
  consumerLogo: null,
  is_manager: false,
  groups: null,
  consumerHasDescriptionField: null,
  consumerGroup: null,
  editorConsumers: []
}

const mutations = {
  SET_BRANDS (state, brands) {
    state.brands = brands
  },
  SET_TEAM (state, data) {
    if (data === null) {
      data = { id: null, consumer: null, is_manager: false, consumer_logo: null, has_description_field: null }
    }
    state.teamId = data.id
    state.consumerName = data.consumer
    state.is_manager = data.is_manager
    state.consumerLogo = data.consumer_logo
    state.consumerHasDescriptionField = data.has_description_field
  },
  SET_GROUPS (state, groups) {
    state.groups = groups
  },
  SET_AUTHENTICATED (state, authenticated) {
    state.authenticated = authenticated
  },
  SET_CONSUMER_GROUP (state, consumerGroup) {
    state.consumerGroup = consumerGroup
  },
  SET_EDITOR_CONSUMERS (state, editorConsumers) {
    state.editorConsumers = editorConsumers
  }
}

// actions
function initGlobalState (store) {
  if (store.state.teamId === null && store.state.authenticated) {
    refreshGlobalState(store)
  }
}

function refreshBrands (store) {
  BrandRepository.fetchTeamBrands(store.state.teamId).then(function (brands) {
    // set brands array
    store.commit('SET_BRANDS', brands)
  })
}

function refreshGroups (store) {
  GroupRepository.fetchGroups().then(function (groups) {
    // set groups array
    store.commit('SET_GROUPS', groups)
  })
}

function refreshGlobalState (store) {
  return TeamRepository.fetchTeam().then(function (teamData) {
    store.commit('SET_TEAM', teamData)
    refreshBrands(store)
    refreshGroups(store)
    return teamData
  })
}

function reset (store) {
  store.commit('SET_AUTHENTICATED', false)
  store.commit('SET_BRANDS', null)
  store.commit('SET_TEAM', null)
  store.commit('SET_GROUPS', null)
  store.commit('SET_CONSUMER_GROUP', null)
}

const getters = {
  isLmrConsumer (store) {
    // return store.CONSUMERS.lameuse.includes(store.consumerName)
    return true
  },
}

const actions = {
  syncFtp ({ commit }, { markerId, showLink }) {
    return MarkerRepository.triggerFTPSync(markerId).then(
      response => {
        const dataLink = response.path_to_marker_data
        const message = i18n.t('marker.ftp.records_link')
        if (showLink !== false) commit('snackbar/show', { href: dataLink, message })
      },
      error => {
        const { response } = error
        response.json()
          .then(json => json)
          .catch(() => {})
          .then(json => {
            const { non_field_errors: nonFieldErrors, detail } = json
            const message = nonFieldErrors || detail || i18n.t('marker.ftp.sync_error')
            commit('snackbar/show', { message, color: 'error' })
          })
      }
    )
  },
  syncImagesFtp ({ commit }) {
    return MarkerRepository.triggerFTPImagesSync().then(
      response => {},
      error => {
        error.response.json()
          .then(json => {
            const { non_field_errors: nonFieldErrors, detail } = json
            const message = nonFieldErrors || detail || i18n.t('marker.ftp.sync_error')
            commit('snackbar/show', { message, color: 'error' })
          })
      }
    )
  },
  getDigitekaXml (context, record) {
    // deprecated this login moved to back
    // map our group to folder on digiteka server
    // there is same map on backend, keep them synced
    if (!record.groups.length) return ''
    let mdtk = record.groups[0].mdtk
    let ownerId = record.groups[0].owner_id
    let zone = record.groups[0].zone
    return fetch(
      `https://www.ultimedia.com/api/search/getvideoinfos/mdtk/${mdtk}/zone/${zone}/owner_id/${ownerId}/external_id/${record.name}`,
    ).then(response => response.text())
  },
  getDigitekaIframe ({ dispatch }, recordName) {
    // deprecated
    return dispatch('getdigitekaXml', recordName)
      .then(text => text.match(/<iframe[^[\]]+iframe>/))
  },
  getDigitekaLink ({ dispatch }, record) {
    if (record.digiteka_id) {
      return new Promise((resolve, reject) => {
        resolve(buildDigitakeLink(record))
      })
    } else {
      return dispatch('getDigitekaXml', record).then(text => {
        const groups = text.match(/video_id><!\[CDATA\[(\w+)/)
        if (groups && groups.length > 0) {
          const dgId = groups[1]
          record.digiteka_id = dgId
          return buildDigitakeLink(record)
        }
      })
    }
  },
  buildDigitekaDirectLink (context, record) {
    let mdtk = record.groups[0].mdtk
    let zone = record.groups[0].zone
    let digitekaId = record.digiteka_id
    return `https://www.ultimedia.com/deliver/generic/iframe/mdtk/${mdtk}/zone/${zone}/src/${digitekaId}`
  }
}

function buildDigitakeLink (record) {
  let mdtk = record.groups[0].mdtk
  let id = record.digiteka_id
  let zone = record.groups[0].zone
  return `https://www.ultimedia.com/default/index/videogeneric/id/${id}/showtitle/1/viewnc/1/mdtk/${mdtk}/zone/${zone}`
}

const modules = {
  snackbar: SnackbarModule
}
const store = new Vuex.Store({state, actions, mutations, getters, modules})

export default store

export {
  store,
  initGlobalState,
  refreshGlobalState,
  refreshGroups,
  reset
}



// WEBPACK FOOTER //
// ./src/store/index.js